export class Resource {
  _id: string;
  type: string;
  name: string;
  address: string;
  city: string;
  postalCode: string;
  contactNumber: string;
  logo?: string;
  association?: string;
}
